import { graphql } from '@/gql'

export const WorkflowVariableFragment = graphql(/* GraphQL */ `
  fragment WorkflowVariableFragment on WorkflowVariable {
    id
    value: id
    label: title
    description
    operators
    ... on WorkflowVariableStringType {
      originMeta @client
    }

    ... on WorkflowVariableOptionType {
      originMeta @client
      options {
        displayOrder
        label
        value
      }
    }
  }
`)

export const ApproverGroupFragment = graphql(/* GraphQL */ `
  fragment ApproverGroupFragment on Approver {
    id
    userGroup {
      ...UserGroupFragment
      ...UsersFragment
    }
    position
  }
`)

export const WorkflowVariableRuleFragment = graphql(/* GraphQL */ `
  fragment WorkflowVariableRuleFragment on WorkflowVariableRule {
    id
    fieldId
    operator
    value
    variable {
      ...WorkflowVariableFragment
    }
  }
`)

export const ApprovalRuleFragment = graphql(/* GraphQL */ `
  fragment ApprovalRuleFragment on ApprovalRule {
    id
    rules {
      ...WorkflowVariableRuleFragment
    }
    approvers {
      ...ApproverGroupFragment
    }
    createdAt
    updatedAt
  }
`)

export const WorkflowFragment = graphql(/* GraphQL */ `
  fragment WorkflowFragment on Approval {
    id
    name
    description
    trigger
    status
    latestVersionId
    approvalRules {
      ...ApprovalRuleFragment
    }
    createdAt
    updatedAt
  }
`)

export const WorkflowsQuery = graphql(/* GraphQL */ `
  query Workflows(
    $account: [ID!]
    $search: String
    $first: Int!
    $page: Int
    $usersFirst: Int!
    $usersPage: Int
  ) {
    approvals(accounts: $account, search: $search, first: $first, page: $page) {
      data {
        ...WorkflowFragment
      }
    }
  }
`)

export const WorkflowVariablesQuery = graphql(/* GraphQL */ `
  query WorkflowVariables($accounts: [ID!], $appliesTo: ApprovalTrigger!, $page: Int!) {
    workflowVariables(accounts: $accounts, appliesTo: $appliesTo, first: 50, page: $page) {
      data {
        ...WorkflowVariableFragment
      }
      paginatorInfo {
        total
        currentPage
        hasMorePages
      }
    }
  }
`)
